import withDiscount from './withDiscount';
import useDiscountData from './useDiscountData';

export { withDiscount, useDiscountData };
